import { useNavigate } from "react-router-dom";
import UserIcon from "../../../assets/icons/header-icons/user-icon.svg";
import { LOGIN_ROUTE, REGISTER, useAppSelector } from "@hypexone/uicore";
import HeaderButtonComponent from "./HeaderButtonComponent";

const LoginButtons = () => {
  const navigate = useNavigate();
  const { domainConfig } = useAppSelector((state) => state.common);

  const handleSignupClick = () => {
    navigate(REGISTER);
  };
  const {langData} = useAppSelector((state) => state.cms);

  return (
    <div className="flex items-center gap-1">
      {/* <img src={UserIcon} alt="user-icon" className="hidden md:block h-3 w-3" /> */}

      <HeaderButtonComponent
        onClick={() => navigate(LOGIN_ROUTE)}
        buttonVariant="login"
        buttonText={langData?.["login"] ?? "Login"}
      />
      {domainConfig?.b2cEnabled && (
        <HeaderButtonComponent
          onClick={handleSignupClick}
          buttonVariant="signup"
          buttonText={langData?.["sign_up"] ?? langData?.["signup"] ?? "Sign Up"}
        />
      )}
    </div>
  );
};

export default LoginButtons;
